import { Pipe, PipeTransform } from '@angular/core';
import { TransportDetail } from '../../configuration/transport.configuration';
import { DataType } from '../../model/common.model';
import { TimeUtilsService, TranslationService } from '@sdbn/common';

@Pipe({
    name: 'transportColumnFormat',
    standalone: false
})
export class TransportColumnFormatPipe implements PipeTransform {

    constructor(
        private translationService: TranslationService,
        private timeUtilsService: TimeUtilsService
    ) { }

    transform(value: any, args?: any[]): string {

        if (value == null) {
            return '';
        }

        if (args.length < 1) {
            return value;
        }

        let detail: TransportDetail = args[0] as TransportDetail;

        switch (detail.dataType) {
            case DataType.BOOLEAN: return this.fromBoolean(value, detail);
            case DataType.DATE: return this.fromDate(value, detail);
            case DataType.DECIMAL: return this.fromDecimal(value, detail);
            case DataType.DICTIONARY: return this.fromDictionary(value, detail);
            case DataType.DATA_DICTIONARY: return this.fromDataDictionary(value, detail);
            case DataType.LOOKUP: return this.fromLookup(value, detail);
            case DataType.NUMBER: return this.fromNumber(value, detail);
            case DataType.OTHERS: return this.fromOthers(value, detail);
            case DataType.STRING: return this.fromString(value, detail);
        }

    }

    private fromBoolean(value: any, detail: TransportDetail): string {
        let key = value ? 'common.enum.boolean.yes' : 'common.enum.boolean.no';
        return this.translationService.translate(key);
    };

    private fromDate(value: any, detail: TransportDetail): string {

        if (value === '') {
            return '';
        }

        if (value.length === 8) {
            return value.substring(6, 8) + '.' + value.substring(4, 6) + '.' + value.substring(0, 4);
        } else {

            // TODO heute Datum muss eigentlich vom Server kommen, da der zugriff auch aus jeder beliebigen andern Zeitzone kommen kann
            let date = new Date();
            let todayString = '' + date.getFullYear() + this.getMonth(date.getMonth()) + this.getDay(date.getDate());

            if (todayString === value.substring(0, 8)) {
                return value.substring(8, 10) + ':' + value.substring(10, 12);
            } else {
                return value.substring(6, 8) + '.' + value.substring(4, 6) + '.' + value.substring(0, 4) + ' ' + value.substring(8, 10) + ':' + value.substring(10, 12);
            }

        }

    };

    private getMonth(value: number): string {
        let result: string = '' + (value + 1);
        if (value < 9) {
            result = '0' + result;
        }
        return result;
    }

    private getDay(value: number): string {
        let result: string = '' + value;
        if (value <= 9) {
            result = '0' + result;
        }
        return result;
    }

    private fromDecimal(value: any, detail: TransportDetail): string {
        return value;
    };

    private fromDictionary(value: any, detail: TransportDetail): string {
        return this.translationService.translate(detail.dictionaryRoot + value);
    };

    private fromDataDictionary(value: any, detail: TransportDetail): string {
        return this.translationService.translate('dd.' + detail.dataDictionaryTable + '.' + value + '.' + detail.dataDictionaryAttribute);
    };

    private fromLookup(value: any, detail: TransportDetail): string {
        return value;
    };

    private fromNumber(value: any, detail: TransportDetail): string {
        if (['current-position-duration', 'waitingTime',
            'current-position-statusDuration', 'processingTimeCurrentProcessing']
            .includes(detail.identifier)) {
                return this.timeUtilsService.formatDuration(value);
        }
        return value;
    };

    private fromOthers(value: any, detail: TransportDetail): string {
        return value;
    };

    private fromString(value: any, detail: TransportDetail): string {

        if (detail.identifier === 'registrationCode') {
            if (value == null || value.length < 10) {
                return value;
            } else {
                return value.substring(0, 5) + ' ' + value.substring(5, 10);
            }
        }
        return value;
    };
}